import React from "react";
import {
  LearningActivityCardLink,
  LearningActivityCardButton,
} from "Components/Module/LearningActivityItem/Actions";
import config from "lib/config";
import {
  getCourseOnlineLinkLabel,
  GetRequestedCourseLink,
  GetRequestedOnlineCourseCatlogueLink,
} from "../../../../functions";

export const SurveyProgramActions = ({
  course,
  isPreview,
  languageContext,
}) => (
  <>
    {course.mandatorySurveySent && !course.completed && !isPreview && (
      <LearningActivityCardLink
        target="_blank"
        rel="noopener noreferrer"
        href={`${config.urlRoot}np/survey.aspx?token=${course.surveyTokenID}`}
      >
        {languageContext("goToSurvey")}
      </LearningActivityCardLink>
    )}
  </>
);

export const OnlineProgramActions = ({
  course,
  languageContext,
  isPortalOverview,
  ProgramSettings,
  onClick,
}) => (
  <>
    {course.requested && !ProgramSettings.managerView && (
      <GetRequestedCourseLink
        courseId={course.courseId}
        label={languageContext("application1")}
      />
    )}

    {((course.isActiveStep && !ProgramSettings.managerView) ||
      isPortalOverview) &&
      !(course.numberOfDaysUntilRegistration > 0) && (
        <>
          {!isPortalOverview ? (
            <LearningActivityCardButton
              onClick={() => onClick()}
              label={languageContext(getCourseOnlineLinkLabel(course, false))}
            />
          ) : (
            <GetRequestedOnlineCourseCatlogueLink
              courseId={course.courseId}
              label={languageContext("showactivity")}
              isPortalOverview={isPortalOverview}
            />
          )}
        </>
      )}
  </>
);

export const ClassroomProgramActions = ({
  ProgramSettings,
  course,
  isPreview,
  languageContext,
  isPortalOverview,
  activityId,
  onClick,
}) => (
  <>
    {course.isActiveStep &&
      !course.requested &&
      !isPortalOverview &&
      !isPreview && (
        <LearningActivityCardButton
          onClick={() => onClick()}
          label={languageContext("showactivity")}
        />
      )}

    {isPortalOverview && (
      <GetRequestedCourseLink
        courseId={course.courseObjectId}
        activityId={activityId}
        label={languageContext("showactivity")}
        isPortalOverview={isPortalOverview}
      />
    )}

    {course.requested && !ProgramSettings.managerView && !isPortalOverview && (
      <GetRequestedCourseLink
        courseId={course.courseObjectId}
        activityId={activityId}
        label={languageContext("registerHere")}
      />
    )}
  </>
);

export const ActivityProgramActions = ({
  course,
  isPreview,
  languageContext,
  onClick,
}) => (
  <>
    {course.isActiveStep &&
      !isPreview &&
      !(course.numberOfDaysUntilRegistration > 0) && (
        <LearningActivityCardButton
          onClick={() => onClick()}
          label={languageContext("displayActivity")}
        />
      )}
  </>
);
